import { Injectable } from '@angular/core';
import { MatDialog, MatDialogState } from '@angular/material/dialog';
import { ModalLoginComponent } from '../components/modal-login/modal-login.component';
import { ModalRegisterComponent } from '../components/modal-register/modal-register.component';
import { ForgotPasswordComponent } from '../components/forgot-password/forgot-password.component';

@Injectable({
  providedIn: 'root'
})
export class ModalLoginService {
  private readonly loginModalId:string = 'login-component'
  private readonly registerModalId:string = 'register-component'
  private readonly forgotPasswordModalId:string = 'forgot-password-component'

  private loginDialog: any;
  private registerDialog: any;
  private forgotPasswordDialog: any;

  constructor(
    private matDialog: MatDialog
  ) { }

  openModalLogin(){
    const dialog = this.matDialog.getDialogById(this.loginModalId);
    if(dialog?.getState() == MatDialogState.CLOSED || !dialog)
      this.loginDialog = this.matDialog.open(ModalLoginComponent,{disableClose:true,id: this.loginModalId, panelClass: 'modal-login-register'});
  }

  closeModalLogin(){
    this.loginDialog?.close();
  }

  openModalRegister(){
    const dialog = this.matDialog.getDialogById(this.registerModalId);
    if(dialog?.getState() == MatDialogState.CLOSED || !dialog)
      this.registerDialog = this.matDialog.open(ModalRegisterComponent,{disableClose:true,id: this.registerModalId, panelClass: 'modal-login-register'});
  }

  closeModalRegister(){
    this.registerDialog?.close();
  }

  openModalForgotPassword(){
    const dialog = this.matDialog.getDialogById(this.forgotPasswordModalId);
    if(dialog?.getState() == MatDialogState.CLOSED || !dialog)
      this.forgotPasswordDialog = this.matDialog.open(ForgotPasswordComponent,{disableClose:true,id: this.forgotPasswordModalId, panelClass: 'modal-login-register'});
  }

  closeModalForgotPassword(){
    this.forgotPasswordDialog?.close();
  }
}
